module.exports = __webpack_public_path__ + "img/202411_03.93defeb5.jpg";